import { Decoder, object, string, nullable, number } from "decoders";

export interface SiteCoordinates {
  latitude: number;
  longitude: number;
}

export interface SiteData {
  siteName: string;
  coordinates: SiteCoordinates | null;
  locationDescription: string;
  purpose: string;
}

export const siteDataDecoder: Decoder<SiteData> = object({
  siteName: string,
  coordinates: nullable(object({ latitude: number, longitude: number })),
  locationDescription: string,
  purpose: string,
});

export function hasCoordinates(site: SiteData): site is SiteData & { coordinates: SiteCoordinates } {
  return site.coordinates !== null;
}
